import axiosClient from "../../../../axiosClient"

// The users selectable in the "Latest QA action taken by" filter — the distinct set of QA
// reviewers who have taken a QA action (excluding the synthetic system/veriff actors). QA-only
// endpoint; returns the same {_id, given_name, family_name, email} shape as the requestor list.
export default async () => {
    const result = await axiosClient.get(`/pre-check-qa-actors`)
    return result.data
}
